module.exports = __webpack_public_path__ + "swan-forum-fe/static/img/empty-message.29ac56c0.png";